export enum Colors {
Obsidian_Light_0 = "#ffffff",
Obsidian_Light_50 = "#f2f2f3",
Obsidian_Light_100 = "#dcdce0",
Obsidian_Light_200 = "#c6c6cd",
Obsidian_Light_300 = "#b1b1b9",
Obsidian_Light_400 = "#9b9ba6",
Obsidian_Dark_500 = "#868693",
Obsidian_Dark_400 = "#787887",
Obsidian_Dark_300 = "#5e5e69",
Obsidian_Dark_200 = "#4a4a54",
Obsidian_Dark_100 = "#37373e",
Obsidian_Dark_50 = "#242429",
Obsidian_Dark_0 = "#131314",
Coral_leaf_50 = "#f4fae9",
Coral_leaf_100 = "#e3f1c6",
Coral_leaf_200 = "#d2e8a2",
Coral_leaf_300 = "#c0df7f",
Coral_leaf_400 = "#afd65b",
Coral_leaf_500 = "#93c822",
Coral_leaf_600 = "#8abc20",
Coral_leaf_700 = "#739c1b",
Coral_leaf_800 = "#5b7c15",
Coral_leaf_900 = "#445c10",
Coral_leaf_950 = "#2c3c0a",
Coral_green_50 = "#ecf9ed",
Coral_green_100 = "#ccefd1",
Coral_green_200 = "#ade5b5",
Coral_green_300 = "#8edb98",
Coral_green_400 = "#6fd17c",
Coral_green_500 = "#50c760",
Coral_green_600 = "#3cc14e",
Coral_green_700 = "#2f973d",
Coral_green_800 = "#257830",
Coral_green_900 = "#1c5924",
Coral_green_950 = "#123a17",
Coral_moss_50 = "#e8f9f4",
Coral_moss_100 = "#c3efe2",
Coral_moss_200 = "#9ee5d0",
Coral_moss_300 = "#78dcbd",
Coral_moss_400 = "#53d2ab",
Coral_moss_500 = "#17c28e",
Coral_moss_600 = "#16b685",
Coral_moss_700 = "#12976f",
Coral_moss_800 = "#0e7858",
Coral_moss_900 = "#0b5941",
Coral_moss_950 = "#073a2b",
Coral_foam_50 = "#e8f9fa",
Coral_foam_100 = "#c3eef1",
Coral_foam_200 = "#9fe4e8",
Coral_foam_300 = "#7adae0",
Coral_foam_400 = "#56d0d7",
Coral_foam_500 = "#1abfc9",
Coral_foam_600 = "#18b4bd",
Coral_foam_700 = "#14959d",
Coral_foam_800 = "#10767d",
Coral_foam_900 = "#0c585c",
Coral_foam_950 = "#08393c",
Coral_sky_50 = "#e6f5fd",
Coral_sky_100 = "#bde5fb",
Coral_sky_200 = "#94d5f8",
Coral_sky_300 = "#6bc4f6",
Coral_sky_400 = "#42b4f3",
Coral_sky_500 = "#1aa4f1",
Coral_sky_600 = "#009aef",
Coral_sky_700 = "#0078ba",
Coral_sky_800 = "#005f94",
Coral_sky_900 = "#00476e",
Coral_sky_950 = "#002e48",
Coral_ink_50 = "#e6f0fe",
Coral_ink_100 = "#bfd8fd",
Coral_ink_200 = "#98c0fb",
Coral_ink_300 = "#70a7fa",
Coral_ink_400 = "#498ff8",
Coral_ink_500 = "#2277f7",
Coral_ink_600 = "#0968f6",
Coral_ink_700 = "#0751c0",
Coral_ink_800 = "#064099",
Coral_ink_900 = "#043071",
Coral_ink_950 = "#031f4a",
Coral_lily_50 = "#f3ebfa",
Coral_lily_100 = "#e0caf1",
Coral_lily_200 = "#cdaae9",
Coral_lily_300 = "#bb89e1",
Coral_lily_400 = "#a869d9",
Coral_lily_500 = "#9548d0",
Coral_lily_600 = "#8934cb",
Coral_lily_700 = "#6b299e",
Coral_lily_800 = "#55207e",
Coral_lily_900 = "#3f185d",
Coral_lily_950 = "#29103d",
Coral_rose_50 = "#fcecf4",
Coral_rose_100 = "#f7cee2",
Coral_rose_200 = "#f2b0d0",
Coral_rose_300 = "#ec93bd",
Coral_rose_400 = "#e775ab",
Coral_rose_500 = "#e25799",
Coral_rose_600 = "#df448e",
Coral_rose_700 = "#ae356f",
Coral_rose_800 = "#8a2a58",
Coral_rose_900 = "#671f41",
Coral_rose_950 = "#43142b",
Coral_fire_50 = "#feeaea",
Coral_fire_100 = "#fbc8c8",
Coral_fire_200 = "#f9a6a7",
Coral_fire_300 = "#f78585",
Coral_fire_400 = "#f56364",
Coral_fire_500 = "#f24142",
Coral_fire_600 = "#f12c2d",
Coral_fire_700 = "#bc2223",
Coral_fire_800 = "#951b1c",
Coral_fire_900 = "#6f1415",
Coral_fire_950 = "#480d0e",
Coral_sun_50 = "#feeee8",
Coral_sun_100 = "#fcd2c4",
Coral_sun_200 = "#fab6a0",
Coral_sun_300 = "#f89a7b",
Coral_sun_400 = "#f67e57",
Coral_sun_500 = "#f46233",
Coral_sun_600 = "#f3501c",
Coral_sun_700 = "#be3e16",
Coral_sun_800 = "#973211",
Coral_sun_900 = "#70250d",
Coral_sun_950 = "#491808",
Coral_mango_50 = "#fdf1e6",
Coral_mango_100 = "#fadabe",
Coral_mango_200 = "#f7c496",
Coral_mango_300 = "#f4ad6d",
Coral_mango_400 = "#f19745",
Coral_mango_500 = "#ee801d",
Coral_mango_600 = "#ec7204",
Coral_mango_700 = "#b85903",
Coral_mango_800 = "#924702",
Coral_mango_900 = "#6d3402",
Coral_mango_950 = "#472201",
Coral_sand_50 = "#fdfbe7",
Coral_sand_100 = "#f9f3c0",
Coral_sand_200 = "#f5ec99",
Coral_sand_300 = "#f2e572",
Coral_sand_400 = "#eede4b",
Coral_sand_500 = "#e8d20c",
Coral_sand_600 = "#dac50b",
Coral_sand_700 = "#b5a409",
Coral_sand_800 = "#908207",
Coral_sand_900 = "#6b6106",
Coral_sand_950 = "#463f04",
Coral_lime_50 = "#f9fbeb",
Coral_lime_100 = "#eff5cb",
Coral_lime_200 = "#e5eeab",
Coral_lime_300 = "#dbe88c",
Coral_lime_400 = "#d1e16c",
Coral_lime_500 = "#c7db4c",
Coral_lime_600 = "#c1d738",
Coral_lime_700 = "#97a82c",
Coral_lime_800 = "#788523",
Coral_lime_900 = "#59631a",
Coral_lime_950 = "#3a4111",
Coral_corn_50 = "#fdf8e6",
Coral_corn_100 = "#faedbe",
Coral_corn_200 = "#f7e296",
Coral_corn_300 = "#f5d86d",
Coral_corn_400 = "#f2cd45",
Coral_corn_500 = "#edbb04",
Coral_corn_600 = "#dfb004",
Coral_corn_700 = "#b99203",
Coral_corn_800 = "#937402",
Coral_corn_900 = "#6d5602",
Coral_corn_950 = "#473801",
Coral_special_Success_green = "#15c688",
Coral_special_Error_red = "#ec4242",
Coral_special_Danger_orange = "#fa904e",
Coral_special_Empasys_blue = "#2277f7",
Coral_special_Overlay_black = "#13131480",
Coral_Indigo_50 = "#eceef9",
Coral_Indigo_100 = "#cdd2ee",
Coral_Indigo_200 = "#afb7e4",
Coral_Indigo_300 = "#909bda",
Coral_Indigo_400 = "#7280d0",
Coral_Indigo_500 = "#5364c5",
Coral_Indigo_600 = "#4053bf",
Coral_Indigo_700 = "#324195",
Coral_Indigo_800 = "#283376",
Coral_Indigo_900 = "#1d2658",
Coral_Indigo_950 = "#131939",
}
